import { action, makeAutoObservable, observable, reaction } from "mobx";
import { VideoSubtitlesSegments } from "@/features/player/api/types";
import { QualityType } from "@/features/player/model/types";
import { RagStore } from "@/features/rag/model/RagStore";
import { StreamingAvatarStore } from "@/features/avatar/store/StreamingAvatarStore";
import { AVATAR_API_URL } from "@/shared/config/player";

export class PlayerStore {
    selectedSub: VideoSubtitlesSegments | undefined;
    quality: QualityType = QualityType.q1080;
    @observable.ref
    rag = new RagStore();
    @observable.ref
    avatar = new StreamingAvatarStore(AVATAR_API_URL);
    answerIsReady = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });

        reaction(
            () => this.rag.answer?.query,
            () => {
                console.log("this.rag.answer true", this.rag.answer?.query);
            },
        );
    }
    setSelectSub(sub: VideoSubtitlesSegments) {
        this.selectedSub = sub;
    }
    setQuality(type: QualityType) {
        this.quality = type;
    }
}
